import React from 'react'
import MenuPage from './Menu/MenuPage.jsx'

export default function Home() {
  return (
    <MenuPage />
 

)
}
